class NBDSellingPlans extends HTMLElement {

  static observedAttributes = [
    "data-variant-id",
    "data-plan-id",
    "data-plan-type",
  ];

  constructor() {
    super();
  }

  connectedCallback() {
    this.planInputs.forEach(el => el.addEventListener('change', this.handlePlanChange.bind(this)));
    this.planTypeInputs.forEach(el => el.addEventListener('change', this.handlePlanTypeChange.bind(this)));
    this.addEventListener('serving:change', this.handleServingChange.bind(this));
  }

  disconnectedCallback() {
    this.planInputs.forEach(el => el.removeEventListener('change', this.handlePlanChange.bind(this)));
    this.planTypeInputs.forEach(el => el.removeEventListener('change', this.handlePlanTypeChange.bind(this)));
    this.removeEventListener('serving:change', this.handleServingChange.bind(this));
  }

  handlePlanChange(event) {
    this.planId = event.target.value;
    this.syncPlanSelection(this.planId);
  }

  syncPlanSelection(id) {
    this.planInputs.forEach(input => {
      if (input.type === 'radio') {
        input.checked = input.value == id;
      } else {
        input.value = id;
      }
    });
  }

  handlePlanTypeChange(event) {
    this.planType = event.target.value;
  }

  handleServingChange(event) {
    this.serving = event.detail;
    this.renderPricePerServing();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render();
  }

  render() {
    this.toggleActivePlan();
    this.toggleActivePlanType();
    this.renderPrices();
  }

  toggleActivePlan() {
    this.groupElements.forEach(group => {
      group.classList.toggle('active', group.dataset.variantId == this.variantId)
    })
  }

  toggleActivePlanType() {
    this.planTypeInputs.forEach(input => {
      input.checked = (input.value === this.planType);
    })
  }

  renderPrices() {
    let plan = this.currentPlanInput;
    if (!plan) return;
    let { price, planPrice, saving, savingType } = plan.dataset;
    price = parseInt(price);
    this.querySelectorAll('.onetime .prices').forEach(el => el.innerHTML = this.pricesHtml(price, ''));
    planPrice = parseInt(planPrice);
    planPrice = isNaN(planPrice) ? 0 : planPrice;
    if (price > planPrice) {
      this.querySelectorAll('.recurring .prices').forEach(el => el.innerHTML = this.pricesHtml(planPrice, price));
      this.querySelectorAll('.plan_badge').forEach(el => el.innerHTML = `Save ${saving}`);
    }
  }

  pricesHtml(price, compare_at_price) {
    let compare = '';
    if (compare_at_price > 0) {
      compare = `<span class="price compare-at-price">${this.formatMoney(compare_at_price)}</span>`
    }

    return `
    ${compare}
    <span class="price">${this.formatMoney(price)}</span>
    `;
  }

  clearPricePerServing() {
    this.querySelectorAll('.price-per-serving').forEach(el => el.innerHTML = '');
  }

  renderPricePerServing() {
    let plan = this.currentPlanInput;
    let { label, units } = this.serving;
    if (!plan || units < 1) {
      this.clearPricePerServing();
      return;
    };
    let { price, planPrice } = plan.dataset;
    this.querySelectorAll('.onetime .price-per-serving').forEach(
      el => el.innerHTML = this.pricePerServingHtml(price, units, label)
    );
    this.querySelectorAll('.recurring .price-per-serving').forEach(
      el => el.innerHTML = this.pricePerServingHtml(planPrice, units, label)
    );
  }

  pricePerServingHtml(pps, units, label) {
    let price = this.formatMoney(pps / units);
    return `
      <span class="pps-price">${price}</span>
      <span class="pps-label">${label}</span>
    `;
  }

  formatMoney(value) {
    return window.NBD.formatMoney(value);
  }

  get RECURRING() {
    return 'recurring';
  }

  get planId() {
    return parseInt(this.dataset.planId);
  }

  set planId(id) {
    this.dataset.planId = id;
    this.planType = this.RECURRING;
    this.dispatchEvent(new CustomEvent("plan:change", { bubbles: true, detail: id }));
  }

  get planType() {
    return this.dataset.planType;
  }

  set planType(value) {
    this.dataset.planType = value;
    this.dispatchEvent(new CustomEvent("plan-type:change", { bubbles: true, detail: value }));
  }

  get variantId() {
    return parseInt(this.dataset.variantId);
  }

  set variantId(id) {
    this.dataset.variantId = id;
  }

  get groupElements() {
    return this.querySelectorAll('nbd-selling-group');
  }

  get planInputs() {
    return this.querySelectorAll('nbd-selling-group input[type="radio"], nbd-selling-group select');
  }

  get planTypeInputs() {
    return this.querySelectorAll('input[name="plan-type"]');
  }

  // The price data lives on the radio in button mode and on the option in select mode.
  get currentPlanInput() {
    return this.querySelector(
      `nbd-selling-group[data-variant-id="${this.variantId}"] input[value="${this.planId}"],
       nbd-selling-group[data-variant-id="${this.variantId}"] option[value="${this.planId}"]`
    );
  }

}

customElements.define('nbd-selling-plans', NBDSellingPlans)
